import React from "react"

import { Element, Image, Text } from "legacy/components/shared/base"
import { PrismicPageDataBodyChallengeCarouselItem } from "types/__generated__/gatsby-graphql"
import { Maybe } from "types/Maybe"

export type ChallengeProps = {
  icon: Maybe<PrismicPageDataBodyChallengeCarouselItem<"challenge_icon">>
  name: Maybe<PrismicPageDataBodyChallengeCarouselItem<"challenge_name">>
  smallImages: boolean
  value: Maybe<PrismicPageDataBodyChallengeCarouselItem<"challenge_value">>
}

export const Challenge: React.FC<ChallengeProps> = ({
  icon,
  name,
  smallImages,
  value,
}): React.ReactElement | null => {
  const imageHeight = icon?.dimensions?.height
  const imageWidth = icon?.dimensions?.width

  return (
    <Element textAlign="center">
      {icon && (
        <Image
          aspectRatio={`${imageWidth} / ${imageHeight}`}
          imageData={icon}
          width={[104, smallImages ? 104 : 208]}
        />
      )}
      {name && (
        <Text
          color="offBlack"
          fontFamily="martel"
          fontSize={["13", "16"]}
          fontWeight="600"
          letterSpacing="wide"
          lineHeight={["22px", "28px"]}
          mt="sm"
          textTransform="uppercase"
        >
          {name}
        </Text>
      )}
      {value && (
        <Text
          color="offBlack"
          fontFamily="prospectus"
          fontSize={["22", "24"]}
          fontWeight="700"
          lineHeight={["28px", "30px"]}
          mt="xsm"
        >
          {value}
        </Text>
      )}
    </Element>
  )
}
